import React from "react";
import { useContent } from "../i18n/LanguageContext";

export default function Team() {
  const team = useContent().team;
  return (
    <section id="team" className="py-20 lg:py-28 bg-[#faf8f4]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-2xl mx-auto reveal">
          <div className="eyebrow mb-4">{team.eyebrow}</div>
          <h2 className="font-serif-lux text-4xl lg:text-5xl text-[#16233d] font-semibold">{team.title}</h2>
          <p className="mt-4 text-[#5c6577] text-lg">{team.text}</p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mt-14">
          {team.members.map((m) => (
            <div key={m.name} className="group">
              <div className="relative rounded-2xl overflow-hidden mb-5">
                <img
                  src={m.img}
                  alt={m.name}
                  className="w-full h-[360px] object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#16233d]/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              </div>
              <h3 className="font-serif-lux text-2xl text-[#16233d]">{m.name}</h3>
              <div className="text-sm text-[#b08d57] font-medium mb-3">{m.role}</div>
              <p className="text-[#5c6577] text-sm leading-relaxed">{m.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
